export const SET_SELECTION_MENU = "SET_SELECTION_MENU";
